// removed by extract-text-webpack-plugin
module.exports = {"colorWhite":"#ffffff","draggableItem":"draggable-editor-item__draggableItem____3GUr2"};


//////////////////
// WEBPACK FOOTER
// ./src/admin/ui/components/drag-and-drop/draggable-editor-item.css
// module id = 617
// module chunks = 0